import { MenuItem, Select, FormControl, InputLabel } from 'components/ui';
import { FormattedMessage } from 'react-intl';

const BUCKET_OPTIONS = ['overdue', 'incoming', 'next_week', 'next_month', 'remaining', 'pending'];

const BucketSelect = ({ name, id, label, margin, value, onChange, onBlur, error }) => {
  const handleChange = (event) => {
    const next = event.target.value === '' ? null : event.target.value;
    onChange({ target: { name, value: next } });
  };

  return (
    <FormControl fullWidth margin={margin}>
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select
        name={name}
        id={id}
        label={label}
        labelId={`${name}-label`}
        onChange={handleChange}
        onBlur={onBlur}
        value={value ?? ''}
        error={error}
      >
        <MenuItem value="">
          <FormattedMessage id="filter.bucket.any" />
        </MenuItem>
        {BUCKET_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            <FormattedMessage id={`filter.bucket.${option}`} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BucketSelect;
